<div>
    <app-tool-bar [title]="'Manage Tickets'" [iconName]="'pi-address-book'" [isSearch]="true" [isDateFilter]="true"
        [selectedProducts]="selectedProducts" [isBulkAction]="true" [bulkActionItems]="bulkActionItems"
        [filtersOptions]="filtersOptions" [isAdd]="true" (handleAdd)="fnHandleAddd()" (search)="handleSearch($event)"
        [exportItems]="exportItems" [isExport]="false" (dateFilter)="handleDateFilter($event)" [showToggleIcon]="true"
        (handleToggleView)="toggleView()" [tableView]="tableView" (resetDateFilter)="handleResetFilters()"
        [isFilterDrawer]="true" (toggleFilter)="toggleFilter()" (ExportData)="export($event)"></app-tool-bar>
</div>

<div class="p-4 flex flex-row gap-3  h-[84vh] overflow-y-auto md:overflow-auto ticket-container w-full mb-3 pb-0">
    <div class="flex-1">
        <div *ngIf="tableView">
            <div class="tab-container">
                <div *ngFor="let tab of ticketStatuses; let i = index" class="outer-tab flex items-center" [ngClass]="{ 'active': activeTicketStatusIndex === i,
      'inactive': activeTicketStatusIndex !== i
     }" (click)="handleTicketStatusFilter(tab, i)">
                    <div class="tab">
                        {{ tab }}
                    </div>

                </div>
            </div>
            <div style="overflow: hidden;">
                <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords"
                    [lazy]="true" (onLazyLoad)="loadTickets($event)" [(selection)]="selectedProducts"
                    [loading]="loading" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
                    [showCurrentPageReport]="true"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem; border-top-left-radius: 10px;"><p-tableHeaderCheckbox /></th>
                            <th *ngFor="let col of displayedColumns" [pSortableColumn]="col.sortable ? col.field : ''">
                                {{ col.header }}
                                <p-sortIcon *ngIf="col.sortable" [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
                        <tr>
                            <td>
                                <p-tableCheckbox [value]="customer" />
                            </td>



                            <td *ngFor="let col of displayedColumns">
                                <ng-container [ngSwitch]="col.type">
                                    <!-- Handle Actions -->
                                    <ng-container *ngSwitchCase="'actions'">
                                        <div *ngIf="!loading" (click)="setTicketEditData(rowData)">
                                            <p-menu [tabindex]="undefined" #menu [model]="leadActionItems"
                                                [popup]="true" appendTo="body"></p-menu>
                                            <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'assigned_to'">
                                        {{
                                        rowData[col.field] || 'N/A'
                                        }}
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'created_by'">
                                        {{
                                        rowData[col.field]?.name || 'N/A'
                                        }}
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'date'">
                                        {{
                                        rowData[col.field] | date: 'dd/MM/yyyy'
                                        }}
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'ticket_status'">
                                        <div class="flex items-center gap-1 rounded-full px-5 py-[1px] w-fit min-w-[120px] font-medium h-[28px]"
                                            [style.borderWidth]="'2px'" [style.borderStyle]="'solid'"
                                            [style.borderColor]="getStatusColor(rowData.ticket_status)"
                                            [style.color]="getStatusColor(rowData.ticket_status)"
                                            style="font-weight: 500;">
                                            <div style="margin-top: 2px;">
                                                <svg width="25px" height="25px" viewBox="0 0 32 32"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <g [attr.stroke]="getStatusColor(rowData.ticket_status)"
                                                        stroke-width="3" fill="none" stroke-linecap="round"
                                                        stroke-linejoin="round">
                                                        <path
                                                            d="M12,13 C9.23857625,13 7,10.7614237 7,8 C7,5.23857625 9.23857625,3 12,3 C14.7614237,3 17,5.23857625 17,8 C17,10.7614237 14.7614237,13 12,13 Z M11.0150512,21 C9.04777237,21 6.37608863,21 3,21 C3.79921286,17.89195 6.4614209,16.2328962 10.9866241,16.0228387">
                                                        </path>
                                                        <polyline
                                                            points="21.0037832 16.5969533 17 21 14.4906972 18.5114193">
                                                        </polyline>
                                                    </g>
                                                </svg>
                                            </div>
                                            {{
                                            rowData.ticket_status || 'N/A'
                                            }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'description'">
                                        <div class="text-center">
                                            <i class="pi pi-info-circle  cursor-pointer info-circle-icon"
                                                pTooltip="{{ rowData[col.field] }}" tooltipPosition="top"
                                                tooltipStyleClass="tooltip-style"></i>
                                        </div>
                                    </ng-container>

                                    <ng-container *ngSwitchCase="'priority'">
                                        <div class="flex items priority-box" [ngClass]="{
                                            'low': rowData[col.field] === 'Low',
                                            'medium': rowData[col.field] === 'Medium',
                                            'high': rowData[col.field] === 'High'
                                        }">
                                            {{
                                            rowData[col.field] || 'N/A'
                                            }}
                                        </div>
                                    </ng-container>

                                    <ng-container *ngSwitchDefault>
                                        {{ rowData[col.field] }}
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loading">
                        <tr>
                            <td colspan="3" class="text-center">
                                <p-progressSpinner></p-progressSpinner>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found "
                                style="height: calc(70vh - 55px);">
                                <p>No records found</p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>

        <div *ngIf="!tableView">
            <app-ticket-card-view [dataSource]="dataSource" [loading]="loading"
                (editTicket)="setTicketEditData($event)"></app-ticket-card-view>
        </div>
    </div>



    <div id="container-div" class="min-w-full md:min-w-[300px] md:max-w-[400px]"></div>

</div>



<p-dialog [modal]="true" [(visible)]="isOpenAddDialog" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
    <ng-container *ngIf="isOpenAddDialog">
        <app-create-ticket (closeDialog)="isOpenAddDialog = false " (reload)="reloadTickets()"
            [users]="users"></app-create-ticket>
    </ng-container>
</p-dialog>

<p-dialog [modal]="true" [(visible)]="isUpdateTicket" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isUpdateTicket">
        <app-create-ticket [type]="'Update'" (reload)="reloadTickets()" [ticketData]="editTicketData"
            (closeDialog)="isUpdateTicket = false" [users]="users"></app-create-ticket>
    </div>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isDeleteTicket" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '30vw' }" [draggable]="false" [resizable]="false">
    <app-delete-ticket [ticketData]="editTicketData" (closeDialog)="isDeleteTicket = false"
        (reload)="reloadTickets()"></app-delete-ticket>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isBulkUpdate" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isBulkUpdate">
        <app-bulk-action (closeDialog)="isBulkUpdate = false" (reload)="reloadTickets()" [users]="users"
            [selectedTickets]="selectedProducts"></app-bulk-action>
    </div>
</p-dialog>


<p-dialog [modal]="true" [(visible)]="isBulkDeleteTicket" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
    <div *ngIf="isBulkDeleteTicket">
        <app-delete-bulk-ticket (closeDialog)="isBulkDeleteTicket = false" (reload)="reloadTickets()"
            [selectedTickets]="selectedProducts"></app-delete-bulk-ticket>
    </div>
</p-dialog>

<app-ticket-filter-sidebar [visible]="visible" [filterLoading]="filterLoading" (removeFilter)="removeFilters()"
    (filtersApplied)="applyFilters($event)"></app-ticket-filter-sidebar>


<p-dialog [modal]="true" [(visible)]="showTicketActivity" [breakpoints]="{ '1199px': '80vw', '575px': '90vw' }"
    closable="false" [style]="{ width: '70vw' }" [draggable]="false" [resizable]="false">
    <div class="flex items-center justify-center dialog-header">
        Ticket Activity
        <div class="absolute right-2">
            <button (click)="showTicketActivity = false" class="outline-none p-5">
                <i class="pi pi-times"></i>
            </button>
        </div>
    </div>

    <div class="dialog-content">
        <div *ngIf="showTicketActivity">
            <app-ticket-middle-view [ticket]="editTicketData"></app-ticket-middle-view>
        </div>
    </div>
</p-dialog>